<template>
  <Transition @after-leave="remove">
    <div
      v-if="message.active"
      :aria-live="ariaLive"
      class="py-3 px-5 w-full sm:w-auto rounded-md sm:rounded-full shadow-2xl border-1 text-white text-center font-semibold pointer-events-auto toast-message"
      :class="message.type"
      @click="dismiss"
      v-html="message.message"
    />
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useToastStore } from './store'
import type { QueuedToastMessage } from './types'

export interface Props {
  message: QueuedToastMessage
}

const props = defineProps<Props>()
const store = useToastStore()

const getAria = (): 'polite' | 'assertive' | undefined => {
  switch (props.message.type) {
    case 'notice':
    case 'warning':
      return 'polite'
    case 'error':
      return 'assertive'
  }
}

let timeout: ReturnType<typeof setTimeout>

const ariaLive = ref(getAria())

const dismiss = () => {
  clearTimeout(timeout)
  store.toggle(props.message, false)
}

const remove = () => store.dismiss(props.message)

onMounted(() => {
  store.toggle(props.message, true)
  if (props.message.duration) {
    timeout = setTimeout(dismiss, props.message.duration)
  }
})

onBeforeUnmount(() => clearTimeout(timeout))
</script>
